var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { BannerStyle, FileUploadErrorBanner, FileUploadList, FileUploadStatusType, Modal } from '@mitchell/react.component.ux';
import { ConvertBytesToMegaBytes, TranslationService } from "../../../common";
import { FileHelperService } from "../../../file";
import { IntelligentAssignmentSummary } from '../../constants';
import { IntelligentPhotoCaptureCommonModalType, IntelligentPhotoCaptureEstimatorCaptureMode } from '../../enums';
import { attachmentIteration, getErrorSummaryMessages } from '../../utilities';
import { StyledFileCountModalBody, StyledUploadModalContent } from './IntelligentAssignmentSummaryComponent.style';
const getCloseButton = (type, onClose, translateFn) => ({
    id: type === IntelligentPhotoCaptureCommonModalType.FILE_UPLOAD_ERROR
        ? IntelligentAssignmentSummary.CLOSE_BUTTON_ID
        : IntelligentAssignmentSummary.FILE_COUNT_MODAL_CLOSE_BUTTON,
    label: translateFn(IntelligentAssignmentSummary.CLOSE),
    onClick: onClose
});
export const IntelligentPhotoCaptureEstimatorModalComponent = (_a) => {
    var { isOpen, onClose, type } = _a, modalProps = __rest(_a, ["isOpen", "onClose", "type"]);
    const translateFn = TranslationService.translate;
    const closeButton = getCloseButton(type, onClose, translateFn);
    switch (type) {
        case IntelligentPhotoCaptureCommonModalType.MAX_PHOTO_LIMIT: {
            const { maxFileCount } = modalProps;
            return (React.createElement(Modal, { id: IntelligentAssignmentSummary.FILE_COUNT_MODAL_ID, isOpen: isOpen, onClose: onClose, primaryBtn: closeButton, maxWidth: "sm" },
                React.createElement(StyledFileCountModalBody, null, translateFn(IntelligentAssignmentSummary.FILE_COUNT_MODAL_MESSAGE, {
                    count: maxFileCount
                }))));
        }
        case IntelligentPhotoCaptureCommonModalType.FILE_UPLOAD_ERROR: {
            const { captureMode, estimatorFileUploadError, fileSizeLimit } = modalProps;
            const uploadErrors = estimatorFileUploadError !== null && estimatorFileUploadError !== void 0 ? estimatorFileUploadError : [];
            const errorMessagesMap = getErrorSummaryMessages(ConvertBytesToMegaBytes(fileSizeLimit !== null && fileSizeLimit !== void 0 ? fileSizeLimit : 0), attachmentIteration.getAllowedFileTypes(captureMode || IntelligentPhotoCaptureEstimatorCaptureMode.BULK_PHOTOS));
            const errorMessages = Array.from(new Set(uploadErrors.map(error => error.uploadError)))
                .filter(error => errorMessagesMap.has(error))
                .map(error => errorMessagesMap.get(error));
            const files = uploadErrors.map((fileUploadError, index) => {
                var _a, _b;
                const status = {
                    message: FileHelperService.getUploadStatusMessage(fileUploadError.uploadError),
                    type: FileUploadStatusType.ALERT
                };
                return {
                    id: (_a = fileUploadError.fileId) !== null && _a !== void 0 ? _a : `${fileUploadError.fileName}-${index}`,
                    fileName: fileUploadError.fileName,
                    fileSize: (_b = fileUploadError.fileSize) !== null && _b !== void 0 ? _b : 0,
                    isDone: true,
                    isUploadFailed: true,
                    status,
                    shouldShowRetry: false
                };
            });
            return (React.createElement(Modal, { id: IntelligentAssignmentSummary.ERROR_MODAL_ID, isOpen: isOpen, onClose: onClose, primaryBtn: closeButton, maxWidth: "sm" },
                React.createElement(StyledUploadModalContent, null,
                    React.createElement(FileUploadErrorBanner, { errorMessages: errorMessages, errorCount: uploadErrors.length, bannerStyle: BannerStyle.ALERT, translateFn: translateFn }),
                    React.createElement(FileUploadList, { files: files, shouldHideThumbnail: false, translateFn: translateFn, shouldShowCompleted: true }))));
        }
        default:
            return React.createElement(React.Fragment, null);
    }
};
//# sourceMappingURL=IntelligentPhotoCaptureEstimatorModalComponent.js.map